import * as React from "react";
import {ReactSVG} from 'react-svg';
import {useSelector} from "react-redux";
import hstatic, {staticHypotheekbondUrl} from "@dnhb/content-api-client/src/util/hstatic";
import {ButtonBase as Button} from "../components/Content";
import {RootState} from "../redux/store";

interface Props {
  style?: {
    [key: string]: number|string|boolean;
  }
}

const BackToIndexButton: React.FC<Props> = ({
  style = {}
}): React.ReactElement => {
  const {base, external} = useSelector((state: RootState) => {
    const {config} = state.application;
    const {framed, prefix} = config;
    const base = `/${prefix}${framed ? '/framed' : ''}`;
    const external = config.landingPage;

    return {
      base, external
    }
  });

  let url = base;
  if (external) {
    url = external;
  }

  return (
    <a
      href={url}
      target={"_parent"}
      className={"theme--highlight-color"}
      style={{width: 'inherit', ...style}}
    >
      <Button
        tabIndex={-1}
        disabled={false}
        className={"f-7 fw-600"}
        style={{
          color: 'inherit',
          border: 0,
          justifyContent: 'flex-start'
        }}
      >
        <i
          className={"theme--bg-highlight-color theme--overlay-color"}
          style={{
            marginRight: '6px',
            width: '32px',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            height: '32px',
            alignItems: 'cente',
          }}
        >
          <ReactSVG
            src={hstatic(`${staticHypotheekbondUrl()}images/icon/back.svg`)}
            style={{
              width: '9px',
              position: 'relative',
              top: '8px',
              left: '-1.5px'
            }}
          />
        </i>

        Terug naar nieuwsoverzicht
      </Button>
    </a>
  )
}

export default BackToIndexButton;
